import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as catalogActions from '../../actions/catalogActions';
import CatalogForm from './CatalogForm';
import CatalogSerializer from '../../services/CatalogSerializer';
import {toastr} from 'react-redux-toastr';
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import * as modalActions from '../../actions/common/modalActions';
import * as pendingPageActions from '../../actions/pendingPageActions';
import {FormattedMessage, injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import CustomModal from '../CustomModal';
import ResetFormModal from "../ResetFormModal";

class CatalogFormContainer extends Component {

    constructor(props, context) {
        super(props, context);
        this.companyId = props.user.company.id;
        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [];

        if (this.isUpdate()) {
            actions.push(this.props.actions.getCatalog(this.props.match.params.id));
        }

        return actions;
    }

    componentDidMount() {
        if (!this.isUpdate()) {
            this.props.actions.resetActiveCatalog()
        }
    }

    submit(catalog) {
        const formData = CatalogSerializer.serialize(catalog);

        if(this.isUpdate()) {
            this.props.actions.updateCatalog(this.props.match.params.id, formData).then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.success(this.props.intl.formatMessage(messages.catalogUpdated));
                this.redirect();
            }).catch(err => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.error(this.props.intl.formatMessage(messages.catalogUpdateError));
                throw err;
            });
        } else {
            this.props.actions.createCatalog(formData).then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.success(this.props.intl.formatMessage(messages.catalogCreated));
                this.redirect();
            }).catch(err => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.error(this.props.intl.formatMessage(messages.catalogCreateError));
                throw err;
            });


        }
    }

    confirmReset() {
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }

    redirect() {
        this.context.router.history.push('/kataloger');
    }

    isUpdate() {
        return this.props.match.params.hasOwnProperty('id');
    }

    render() {

        let { catalog } = this.props;

        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">
                                    {
                                        this.isUpdate() ?
                                        this.props.intl.formatMessage(messages.catalogUpdate) :
                                        this.props.intl.formatMessage(messages.catalogCreate)
                                    }
                                </h1>
                                {/*<h5 className="font-weight-normal">Upload kataloger som skal vises på jeres virksomheds profil.</h5>*/}
                                <CatalogForm
                                    initialValues={catalog}
                                    onSubmit={this.submit.bind(this)}
                                    handleReset={this.handleReset.bind(this)}
                                    isUpdate={this.isUpdate()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <ResetFormModal
                    modalTitle={this.props.intl.formatMessage(messages.resetModalTitle)}
                    modalContent={
                        <p>
                            <FormattedMessage
                                id="reset.modal.message"
                                defaultMessage="Are you sure, you want to cancel? All of your alterations will be lost."
                            />
                        </p>}
                    confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                    closeText={this.props.intl.formatMessage(messages.buttonNo)}
                    handleConfirm={() => {this.confirmReset()}}
                />
            </div>
            </WithResolvedPromises>
        );
    }
}

CatalogFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        catalog: CatalogSerializer.unserialize(state.catalogs.active),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                catalogActions,
                submitButtonActions,
                pendingPageActions,
                modalActions,
            ), dispatch)
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CatalogFormContainer));





// WEBPACK FOOTER //
// ./web/src/components/catalog/CatalogFormContainer.jsx